import { RouteObject } from "react-router-dom";
import { lazy } from "react";

import { indentMenuItems } from "../mainMenuListIems";
import { generalSettingRouteObject, settingMenu } from "../Settings/GeneralSettingRouteObject";
import { Settings, Home } from "react-feather";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import PortraitIcon from "@mui/icons-material/Portrait";
import { companySettingMenu, companySettingRouteObject } from "../CompanySettings/CompanySettingRouteObject";
import { userManagementUtil } from "@siba/utilities";
//import Audit from "./Audit/Audit";
import IssueReview from "./IssueReview/IssueReview";
//import BlankPageWithOutlet from "../BlankPageWithOutlet";

/**
 * Component imports for Home module
 * **/
//const BlankPageWithOutlet = lazy(() => import('../BlankPageWithOutlet'));
const Layout = lazy(() => import("../../Components/DefaultLayout/Layout"));
const Dashboard = lazy(() => import("./Dashboard/Dashboard"));

// const ProfileAnalysis = lazy(() => import("./ProfileAnalysis/ProfileAnalysis"));
const IssueForm = lazy(() => import("./IssueForm/IssueForm"));

const settingsValObj = userManagementUtil.isUserAdmin()
    ? {
          name: "General Settings",
          path: "/home/Settings",
          items: settingMenu,
          icon: Settings
      }
    : {
          name: "Company Settings",
          path: "/home/organisation/Settings",
          items: companySettingMenu,
          icon: Settings
      };

const dashBoardObj = userManagementUtil.isUserAdmin() && {
    name: "Dashboard",
    path: "/home",
    items: [],
    icon: Home
};

const menu = indentMenuItems([
    dashBoardObj,

    // {
    //     name: "Audit",
    //     path: "/Home/Audit/Audit",
    //     items: undefined,
    //     icon: PersonSearchIcon
    // },

    {
        name: "Report Issue",
        path: "/Home/IssueForm",
        items: undefined,
        icon: PersonSearchIcon
    },
    {
        name: "Review Issues",
        path: "/Home/IssueReview",
        items: undefined,
        icon: PortraitIcon
    },

    settingsValObj
]);

/***
 * Object that defines the routes for CRM module.
 */
export const homeRouteObject: RouteObject = {
    path: "home",
    element: <Layout layoutMenu={{ menu, title: "HOME" }} />,
    children: [
        { path: "", element: <Dashboard /> },
        userManagementUtil.isUserAdmin() ? generalSettingRouteObject : {},
        companySettingRouteObject,
        // { path: "Audit/Audit", element: <Audit /> },

        { path: "IssueReview", element: <IssueReview /> },
        { path: "IssueForm", element: <IssueForm /> }
    ]
};
